<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="handleSubmit">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.title.$invalid && $v.$dirty }"
                  >
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naziv</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="title"
                      />
                      <form-error
                        :model="$v.title"
                        :dirty="$v.$dirty"
                        label="Naziv"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.fileName.$invalid && $v.$dirty }"
                  >
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Dokument</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        accept="image/*"
                        class="form-control form-control-custom"
                        ref="document"
                        @change="handleDocumentUpload"
                      >
                      <form-error
                        :model="$v.fileName"
                        :dirty="$v.$dirty"
                        label="Dokument"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.companyId.$invalid && $v.$dirty }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                    Komitent
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div>
                        <treeselect
                          v-model="companyId"
                          loadingText="Učitavanje..."
                          noResultsText="Nema rezultata"
                          searchPromptText="Unesite naziv komitenta"
                          :load-options="loadCompanies"
                          :async="true"
                          :options="companies"
                          placeholder="Izaberite komitenta"
                        />
                        <form-error
                          :model="$v.companyId"
                          :dirty="$v.$dirty"
                          label="Komitent"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Zaštićen?
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="isProtected"
                          id="is-protected"
                        />
                        <label for="is-protected"></label>
                      </div>
                    </div>
                  </div>

                </div>
                
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link exact :to="{ name: 'CustomerFiles' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
        <!-- <div class="col-12 col-md-auto ms-md-auto mt-3 mt-md-0 ms-auto">
          <a href="#" class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> Delete Category
          </a>
        </div> -->
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import { required } from 'vuelidate/lib/validators';

import { translations } from '@/mixins';
import api from '@/services/api';
import validations from './validation-schema/add';
import FormError from '../shared/form-errors/FormError.vue';

export default {
  name: 'AddCustomerFile',
  components: { Treeselect, FormError },
  mixins: [translations],
  validations: {
    ...validations,
    fileName: {
      required,
    },
    companyId: {
      required,
    },
  },
  data() {
    return {
      title: '',
      file: '',
      fileName: '',
      companyId: null,
      isProtected: false
    };
  },
  computed: {
    companies() {
      return this.$store.getters.getCompanies.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
    },
  },
  methods: {
    handleSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const file = this.$refs.document.files[0];
      const { title, companyId, isProtected } = this;

      const formData = new FormData();

      formData.append('title', title);
      formData.append('file', file);
      formData.append('companyId', companyId);
      formData.append('protected', isProtected);

      api
        .createCustomerFile(formData)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'CustomerFiles' });
        });
    },
    handleDocumentUpload() {
      const file = this.$refs.document.files[0];

      if (!file) {
        this.file = '';
        this.fileName = '';
        return;
      }

      this.fileName = file.name;

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        this.file = e.target.result;
      };
    },
    loadCompanies({ callback, searchQuery }) {
      this.$store
        .dispatch("getCompanies", {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: "title",
        })
        .then(() => {
          callback(null, this.companies);
        });
    },
  },
};
</script>